<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import Vue from 'vue';
import dayjs from 'dayjs';
import Noty from 'noty';
import Echo from 'laravel-echo';
import {
  filter as _filter,
  findIndex as _findIndex,
  head as _head,
  isEmpty as _isEmpty,
} from 'lodash-es';

window.Pusher = require('pusher-js');

const loginpath = window.location.pathname;

export default {
  name: 'App',
  data() {
    return {
      pusher: [],
    };
  },
  methods: {
    getTimezones() {
      this.$http('timezones').then(({ data }) => {
        this.$store.dispatch('timezones/setTimezones', data.timezones);
      });
    },
    notify(type, text, killer = false, timeout = 2000) {
      new Noty({
        type,
        layout: 'topRight',
        theme: 'metroui',
        text,
        timeout,
        progressBar: true,
        closeWith: ['click'],
        queue: 'global',
        killer,
        visibilityControl: true,
      }).show();
    },
    setOptions(email) {
      this.$store
        .dispatch('dealerOptions/getOptions', email)
        .then(({ data }) => {
          this.$store.commit('dealerOptions/setOptions', data);
        });
    },
    getOption(option) {
      const setting = _head(
        _filter(this.$store.state.dealerOptions.options, {
          name: option,
        })
      );
      if (!setting) return null;
      return setting.value;
    },
    getContainerOption(option) {
      const index = _findIndex(
        this.$store.state.dealerOptions.isCurrentlyEditing,
        {
          name: option,
        }
      );

      if (this.$store.state.dealerOptions.isCurrentlyEditing[index].value) {
        return 'border:3px solid #e74c3c;box-shadow: 4px 4px 4px #c0392b;';
      }
      return '';
    },
    getDealerSetting() {
      this.$store
        .dispatch('dealerOptions/getOptions', this.$auth.user().email)
        .then(({ data }) => {
          this.$store.commit('dealerOptions/setOptions', data);
        });
    },
    centralRefresh() {
      if (process.env.VUE_APP_DISABLE_SSO) {
        return;
      }
      if (this.$auth.check()) {
        this.$http
          .post('central/refresh', {
            central_token: this.$cookies.get('current_central_token'),
          })
          .then(({ data }) => {
            if (!data) {
              this.$auth.logout();
            }
          });
      }
    },
    ssoLogoutListener() {
      Vue.prototype.$echo.channel('sso-logout').listen('SSOLogout', (e) => {
        let centralId = this.$auth.user()
          ? this.$auth.user().central_id
          : this.$route.query.user_central_id;

        if (centralId != e.user_central_id) {
          return;
        }

        if (this.$route.query.user_central_id) {
          this.goBack();
          return;
        }

        this.logout();
      });
    },
    logout() {
      this.$http.get('/okta/logout').then(({ data }) => {
        this.$auth.logout();
        localStorage.removeItem('nextUrl');
        window.location.href = data;
      });
    },
    goBack() {
      this.$http
        .get('/okta/get-logout-link', {
          params: {
            user_central_id: this.$route.query.user_central_id,
          },
        })
        .then(({ data }) => {
          window.location.href = data;
        });
    },
    async initPusher() {
      await this.$http.get('get-env/').then((result) => {
        this.pusher = result.data;
        this.setupPusher();
      });
    },
    setupPusher() {
      Vue.prototype.$echo = new Echo({
        broadcaster: 'pusher',
        key: this.pusher.pusher_key,
        cluster: this.pusher.pusher_cluster,
        forceTLS: true,
        authEndpoint: '/broadcasting/auth',
        encrypted: true,
        auth: {
          headers: {
            Authorization: `Bearer ${this.$auth.token()}`,
          },
        },
      });

      this.ssoLogoutListener();
    },
  },
  computed: {
    currentDate() {
      return dayjs().format();
    },
    user() {
      return this.$auth.user();
    },
  },
  mounted() {
    if (!_isEmpty(this.user)) {
      this.setLayout(this.user.dealer.layout);
    }
  },
  created() {
    this.getTimezones();
    if (this.$auth.check()) {
      this.$http.defaults.headers.common.Authorization = `Bearer ${this.$auth.token()}`;
      this.setOptions(this.user.email);
    }

    this.initPusher();

    Vue.prototype.$notify = this.notify;
    Vue.prototype.$currentDate = this.currentDate;
    Vue.prototype.$getSetting = this.getOption;
    Vue.prototype.$getContainerOption = this.getContainerOption;
    Vue.prototype.$fetchDealerOption = this.getDealerSetting;

    setTimeout(() => {
      this.$auth.fetchUser();
    }, 60000);
  },
};
</script>
<style lang="stylus">
.gradient-title-right {
  background-image: linear-gradient(to right, rgba(249, 180, 24,0), rgba(249, 180, 24,1));
}
.gradient-title-left {
  background-image: linear-gradient(to left, rgba(249, 180, 24,0), rgba(249, 180, 24,1));
}
.v-select {
  margin-top: 4px;
  padding-top: 12px;
}

.v-select .vs__search::placeholder,
.v-select .vs__dropdown-toggle,
.v-select .vs__dropdown-menu {
  border-radius: 0;
  border: none;
  border-bottom: 1px #888888 solid;
  font-size: 16px;
}
// Stackoverflow(https://stackoverflow.com/questions/46135063/how-can-i-stop-sweetalert-scrolling-to-top-after-clicking-ok/61479140#61479140)
body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) { overflow-y: visible !important; }
</style>
